import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";

import { JPWidgetConf } from "../../constants/AppConstants";
import config from "../../config";
import { useLoadJPWidget } from '../../hooks/useLoadJPWidget';

const JPWidget = ({ params, userId }) => {
    const { isWidgetBundleLoaded } = useLoadJPWidget();

    const widgetRef = useRef(false);

    const [shouldJPWidgetBeRerendered, setShouldJPWidgetBeRerendered] =
        useState(false);
    useEffect(() => {
        const initJPWidget = () => {
            try {
                if (!window.OtrlJPWidget) {
                    return;
                }
                const { init } = window.OtrlJPWidget;
                if (widgetRef.current && init) {
                    init({
                        id: widgetRef.current.id,
                        dataLayerName: config.get("gtmDataLayer"),
                        enableModalHeightResize: true,
                        ...params,
                    });
                }
            } catch (error) {
                console.error("Error initializing JPWidget:", error);
            }
        };

        setShouldJPWidgetBeRerendered(true);
        setTimeout(() => {
            setShouldJPWidgetBeRerendered(false);
            initJPWidget();
        }, 0);

        /*eslint-disable */
    }, [userId, isWidgetBundleLoaded]);

    if (shouldJPWidgetBeRerendered) {
        return null;
    }

    return (
        <div
            ref={widgetRef}
            className="otrl-jpWidget-external-component"
            id={JPWidgetConf.ID}
        >
            <span className="otrl circle-spinner" />
        </div>
    );
};

JPWidget.propTypes = {
    params: PropTypes.object,
    userId: PropTypes.number,
};

export default JPWidget;



// WEBPACK FOOTER //
// ./src/components/widget/JPWidget.js